import { render, staticRenderFns } from "./_storeFooter.vue?vue&type=template&id=552bc6af&"
import script from "./_storeFooter.vue?vue&type=script&lang=js&"
export * from "./_storeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports